import React, { useState, useEffect } from 'react';
import { Loader } from 'elmo-elements';
import { AppContext, IAppContext } from './lib/context';
import { authenticatingUser } from './lib/auth';
import { Routes } from './routes';

const App = () => {
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [apps, setApps] = useState(null);
  const [isOpenVPNEnabled, setIsOpenVPNEnabled] = useState(false);

  const onLoad = async () => {
    try {
      const {
        user: currentUser,
        apps: currentApps,
        openVpnEnabled,
      } = await authenticatingUser();
      if (currentUser && currentApps) {
        setUser(currentUser);
        setApps(currentApps);
        setIsOpenVPNEnabled(openVpnEnabled);

        if (process.env.REACT_APP_ENV === 'production') {
          window.pendo.initialize({
            visitor: {
              id: currentUser.uuid,
              email: currentUser.email,
              /* eslint-disable-next-line camelcase */
              full_name: `${currentUser.firstName} ${currentUser.lastName}`,
              role: currentUser.roleName,
            },
            account: {
              // Since Hub only services internal ELMO staff, we just
              // hardcode "elmo" as the tenant identifier
              id: 'elmo',
            },
          });
        }
      }
      userHasAuthenticated(true);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('AUTH:App', err);
    }

    setIsAuthenticating(false);
  };

  useEffect(() => {
    onLoad();
  }, []);

  const appState: IAppContext = {
    isAuthenticated,
    user,
    apps,
    isOpenVPNEnabled,
  };

  return isAuthenticating ? (
    <Loader type="spinner" />
  ) : (
    <AppContext.Provider value={appState}>
      <Routes />
    </AppContext.Provider>
  );
};

export default App;
